import { render, staticRenderFns } from "./confirm-deactivate-old-card.vue?vue&type=template&id=79e25f40&"
import script from "./confirm-deactivate-old-card.vue?vue&type=script&lang=js&"
export * from "./confirm-deactivate-old-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports